import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container } from '../components/layout/Primitives';
import { Button } from '../components/ui/Button';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { logout, selectAuthReady, selectAuthUser } from '../store/actions/authActions';

export default function Account() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const ready = useAppSelector(selectAuthReady);
  const user = useAppSelector(selectAuthUser);
  const meLoading = useAppSelector((s) => s.auth?.meLoading ?? false);

  const name =
    user &&
    `${[user.firstName, user.lastName].filter(Boolean).join(' ') || user.email || 'Client'}`.trim();

  if (!ready && !meLoading) {
    return (
      <div className="animate-fade-in">
        <section style={{ background: 'hsla(38,25%,90%,0.5)', borderBottom: '1px solid hsl(35,18%,84%)', padding: 'clamp(3rem,8vw,6rem) 1.5rem', textAlign: 'center' }}>
          <h1 className="font-display" style={{ margin: 0, fontSize: 'clamp(2.25rem,5vw,3.5rem)' }}>
            {t('modamai.account.title')}
          </h1>
          <p style={{ margin: '1.25rem auto 0', maxWidth: '32rem', opacity: 0.65 }}>
            {t('modamai.account.guestLead')}
          </p>
          <Link to="/login" style={{ display: 'inline-block', marginTop: '2rem' }}>
            <Button as="span" $variant="luxe" $size="lg">
              {t('modamai.auth.signIn')}
            </Button>
          </Link>
        </section>
      </div>
    );
  }

  return (
    <div className="animate-fade-in">
      <section style={{ background: 'hsla(38,25%,90%,0.5)', borderBottom: '1px solid hsl(35,18%,84%)', padding: 'clamp(3rem,8vw,5rem) 1.5rem', textAlign: 'center' }}>
        <p className="font-mono-luxe" style={{ margin: '0 0 1rem', fontSize: '11px', color: '#524D46' }}>
          {t('modamai.account.kicker')}
        </p>
        <h1 className="font-display" style={{ margin: 0, fontSize: 'clamp(2.25rem,5vw,3.5rem)' }}>
          {meLoading ? t('modamai.account.nameLoading') : name || t('modamai.account.nameFallback')}
        </h1>
      </section>

      <Container style={{ maxWidth: '36rem', padding: 'clamp(3rem,6vw,5rem) 1.5rem' }}>
        <div style={{ background: 'hsla(38,25%,90%,0.35)', padding: 'clamp(1.75rem,4vw,2.5rem)' }}>
          <p style={{ margin: '0 0 0.5rem', fontSize: '0.8125rem', opacity: 0.55 }}>{t('modamai.account.signedInAs')}</p>
          <p style={{ margin: '0 0 2rem', fontSize: '1rem' }}>
            {(user?.email ?? '').trim() || t('modamai.account.emailFallback')}
          </p>
          <Button
            type="button"
            $variant="outlineLuxe"
            $size="lg"
            onClick={() => dispatch(logout())}
          >
            {t('modamai.account.signOut')}
          </Button>
          <p style={{ marginTop: '2rem', fontSize: '0.8125rem', opacity: 0.55, lineHeight: 1.6 }}>
            {t('modamai.account.ordersNote')}
          </p>
        </div>
      </Container>
    </div>
  );
}
